import { Head, Link } from "@inertiajs/react"
import {
  AlertTriangle,
  Briefcase,
  FileText,
  TrendingUp,
  UserCheck,
  UserPlus,
  Users,
} from "lucide-react"

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import AdminLayout from "@/layouts/admin-layout"
import type { AdminDashboardIndex } from "@/types/serializers"

function StatCard({
  title,
  value,
  icon: Icon,
}: {
  title: string
  value: number
  icon: React.ComponentType<{ className?: string }>
}) {
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between pb-2">
        <CardTitle className="text-muted-foreground text-sm font-medium">
          {title}
        </CardTitle>
        <Icon className="text-muted-foreground h-4 w-4" />
      </CardHeader>
      <CardContent>
        <p className="text-foreground text-2xl font-bold">{value}</p>
      </CardContent>
    </Card>
  )
}

export default function AdminDashboard({ stats }: AdminDashboardIndex) {
  return (
    <AdminLayout>
      <Head title="Panel de Administración | KrownFT" />

      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <h1 className="text-foreground text-2xl font-bold">
            Panel de Administración
          </h1>
          <Link
            href="/admin/users"
            className="bg-krown-500 hover:bg-krown-400 inline-flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-medium text-white transition-colors"
          >
            <Users className="h-4 w-4" />
            Gestionar Usuarios
          </Link>
        </div>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          <StatCard
            title="Total Usuarios"
            value={stats.total_users}
            icon={Users}
          />
          <StatCard
            title="Nuevos Hoy"
            value={stats.new_users_today}
            icon={UserPlus}
          />
          <StatCard
            title="Nuevos esta Semana"
            value={stats.new_users_week}
            icon={TrendingUp}
          />
          <StatCard
            title="Publicaciones"
            value={stats.total_posts}
            icon={FileText}
          />
          <StatCard
            title="Reportes Pendientes"
            value={stats.pending_reports}
            icon={AlertTriangle}
          />
        </div>

        <h2 className="text-foreground text-lg font-semibold">
          Usuarios por Rol
        </h2>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          <StatCard
            title="Jugadores"
            value={stats.players_count}
            icon={UserCheck}
          />
          <StatCard
            title="Scouts"
            value={stats.scouts_count}
            icon={UserCheck}
          />
          <StatCard title="Clubes" value={stats.clubs_count} icon={UserCheck} />
          <StatCard
            title="Oportunidades"
            value={stats.total_opportunities}
            icon={Briefcase}
          />
        </div>
      </div>
    </AdminLayout>
  )
}
